import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer, NodeViewWrapper } from '@tiptap/react';
import { Rnd } from 'react-rnd';

const ResizableVideoComponent = ({ node, updateAttributes }) => (
    <NodeViewWrapper className="resizable-video">
        <Rnd
            size={{ width: node.attrs.width, height: node.attrs.height }}
            lockAspectRatio
            enableResizing={{ bottomRight: true }}
            disableDragging
            bounds="parent"
            style={{ position: 'relative', display: 'inline-block' }}
            resizeHandleComponent={{ bottomRight: <div className="resize-handle" /> }}
            onResizeStop={(_, __, ref) =>
                updateAttributes({ width: ref.offsetWidth, height: ref.offsetHeight })
            }
        >
            <video
                src={node.attrs.src}
                style={{ width: '100%', height: '100%', display: 'block' }}
                controls
                muted
                playsInline
            />
        </Rnd>
    </NodeViewWrapper>
);

export const ResizableVideo = Node.create({
    name: 'resizableVideo',
    group: 'block',
    atom: true,           // leaf node
    draggable: true,
    selectable: true,

    addAttributes() {
        return {
            src: {},
            width: { default: 480 },
            height: { default: 270 },
        };
    },

    parseHTML() {
        return [{ tag: 'video[data-type="resizable-video"]' }]; // ✅ 수정: 불필요한 백슬래시 제거
    },

    renderHTML({ HTMLAttributes }) {
        return [
            'video',
            mergeAttributes(
                { 'data-type': 'resizable-video', controls: true },
                HTMLAttributes
            ),
        ];
    },

    addNodeView() {
        return ReactNodeViewRenderer(ResizableVideoComponent);
    },
});
